import Styles from "./TestComponentStyles.module.css";

import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import HighlightOffSharpIcon from "@mui/icons-material/HighlightOffSharp";
import { useTestStore } from "../../hooks/store";
import { useEffect, useRef, useState } from "react";
import { CircularProgress, Divider } from "@mui/material";
import {
  formatTestDuration,
  testStatus,
  testType as testTypeHeler,
} from "../../utils/testHelper";
export function TestFinish() {
  const testStore = useTestStore();
  const { userAnswers, questionList, testType, startTime, endTime } = testStore;
  const rigthArrLength = useRef(
    userAnswers.filter((item) => item.is_right).length,
  );
  const isPassed = useRef();
  const minPassed = useRef();

  const minQuestionsToAccept = () => {
    // eslint-disable-next-line default-case
    switch (testType.type) {
      case testTypeHeler.bilet.type:
        isPassed.current = (rigthArrLength.current / questionList.length) * 100;

        minPassed.current = 90;
        return `${questionList.length * 0.9}`;
      case testTypeHeler.exam.type:
        isPassed.current = (rigthArrLength.current / questionList.length) * 100;
        minPassed.current = 90;
        return `${questionList.length * 0.9}`;
      case testTypeHeler.theme.type:
        isPassed.current = (
          (rigthArrLength.current / questionList.length) *
          100
        ).toFixed(0);
        minPassed.current = 100;
        return `${questionList.length}`;
      case testTypeHeler.marathon.type:
        return testTypeHeler.marathon.conditions.allovedErrors;
    }
  };
  const [loading, setLoading] = useState();
  useEffect(() => {
    setLoading(testStore.testLoading);
  }, [testStore.testLoading]);

  const handleInitTest = async () => {
    testStore.setLoading();
    await testStore.initTest(testStore.biletId);
    setTimeout(() => {
      testStore.stopLoading();
    }, 2000);
  };

  const handleInitPreview = () => {
    testStore.initPreview(
      testStore.questionList,
      testStore.userAnswers,
      testStore.testTitle,
      () => {
        testStore.handleTestPreview(testStore.testType, testStatus.finish);
      },
    );
  };

  return (
    <section className={Styles.finish_section}>
      {isPassed.current >= minPassed.current ? (
        <div style={{ maxWidth: "500px", width: "90%" }}>
          <div className={Styles.finish_header}>
            <CheckCircleOutlineSharpIcon
              fontSize="large"
              style={{
                color: "var(--baze-correct)",
                width: "50px",
                height: "50px",
              }}
            />
            <h4>Тест пройден</h4>
          </div>
          <div className={Styles.finish_result}>
            <h5>
              Правильные ответы:{" "}
              <span>
                {rigthArrLength.current} из {questionList.length}
              </span>
            </h5>
            <Divider sx={{ width: "100%" }} />
            <h5>
              Порог сдачи:{" "}
              <span>
                {minQuestionsToAccept()} из {questionList.length}
              </span>
            </h5>
            <Divider sx={{ width: "100%" }} />
            <h5>
              Время выполнения:{" "}
              <span>{formatTestDuration(startTime, endTime)}</span>
            </h5>
            <Divider sx={{ width: "100%" }} />
          </div>
        </div>
      ) : (
        <div style={{ maxWidth: "500px", width: "90%" }}>
          <div className={Styles.finish_header}>
            <HighlightOffSharpIcon
              style={{
                color: "var(--baze-wrong)",
                width: "50px",
                height: "50px",
              }}
            />
            <h4>Тест не пройден</h4>
          </div>
          <div className={Styles.finish_result}>
            <h5>
              Правильные ответы:
              <span>
                {rigthArrLength.current} из {questionList.length}
              </span>
            </h5>
            <Divider sx={{ width: "100%" }} />
            <h5>
              Порог сдачи:
              <span>
                {minQuestionsToAccept()} из {questionList.length}
              </span>
            </h5>
            <Divider sx={{ width: "100%" }} />
            <h5>
              Время выполнения:
              <span>{formatTestDuration(startTime, endTime)}</span>
            </h5>
            <Divider sx={{ width: "100%" }} />
          </div>
        </div>
      )}
      <div className={Styles.finish_actions}>
        <button
          disabled={loading}
          onClick={handleInitPreview}
          className="secondary">
          Мои ответы
        </button>
        <button onClick={handleInitTest} disabled={loading}>
          {loading ? (
            <CircularProgress
              style={{ height: "18px", width: "18px" }}
              color="white"
            />
          ) : (
            "Начать заново"
          )}
        </button>
      </div>
    </section>
  );
}
